<script>
import secoordsAdd from "@/views/dataManage/secoords/secoords-add.vue";
import sempAdd from "@/views/dataManage/semp/semp-add.vue";
import backfillAdd from "@/views/dataManage/backfill/backfill-add.vue";
export default {
  name: "AddDataDialog",
  components: { secoordsAdd, sempAdd, backfillAdd },
  props: {
    section: {
      title: String,
      visible: Boolean,
      operate: String,
      formData: {
        secoordsList: Array,
        sempList: Array,
        backfillList: Array
      },
    },
  },
  data() {
    const piCheck = (rule, value, callback) => {
      let reg =  /^[0-9]\d*$/;
      if (!reg.test(value)) {
        callback(new Error("请输入正整数"));
      }
      callback();
    };
    const sempCheck = (rule, value, callback) => {
      if (value.length < 2) {
        callback(new Error("测压管线数量不得少于2条"));
      }
      callback();
    }
    const backfillCheck = (rule, value, callback) => {
      if (value.length > 0 && value.length < 3) {
        callback(new Error("回填土层不得少于3条"));
      }
      callback();
    }
    return {
      isFullScreen: false,
      secoords: {
        visible: false,
        formData: {}
      },
      semp: {
        visible: false,
        formData: {}
      },
      backfill: {
        visible: false,
        formData: {}
      },
      typeList: [],
      mpcdList: [],
      rules: {
        damnm: [
          { required: true, message: '请输入断面名称', trigger: 'blur' },
        ],
        damcd: [
          { required: true, message: "请输入断面编号", trigger: "blur" },
          { required: true, trigger: "blur", validator: piCheck }
        ],
        endX: [
          { required: true, message: '请输入浸润线X终点坐标', trigger: 'blur' },
        ],
        endY: [
          { required: true, message: '请输入浸润线Y终点坐标', trigger: 'blur' },
        ],
        wallType: [
          { required: true, message: '请选择坝类', trigger: 'blur' },
        ],
        secoordsList: [
          { required: true, message: '请选择坝类', trigger: 'blur' },
        ],
        sempList: [
          { required: true, message: '请添加测压管线', trigger: 'blur' },
          // { required: true, trigger: "blur", validator: sempCheck }
        ],
        backfillList: [
          { trigger: "blur", validator: backfillCheck }
        ],
        no: [
          { required: true, message: "请输入序号", trigger: "blur" },
          { required: true, trigger: "blur", validator: piCheck }
        ],
      }
    }
  },
  methods: {
    init() {
      this.request.get('/rm-sdictionary/v1/query/'+ '05').then(
          (res) => {
            if (res.ok) {
              this.typeList = res.data;
            } else {
              this.$message.error(res.error.message);
            }
          }
      );
    },
    handleClose() {
      this.section.formData = {
        secoordsList: [],
        sempList: []
      };
      this.$refs["df"].clearValidate();
    },
    handleChange(val) {
      if (val === '0501') {
        this.section.formData.secoordsList = [
          {no: 1, type: '1006', name: '左下底点', x: 0, y: 0},
          {no: 2, type: '1005', name: '左上顶点', x: 0, y: 0},
          {no: 3, type: '1007', name: '右上顶点', x: 0, y: 0},
          {no: 4, type: '1008', name: '右下底点', x: 0, y: 0},
        ];
      } else {
        this.section.formData.secoordsList = [
          {no: 1, type: '1006', name: '左下底点', x: 0, y: 0},
          {no: 2, type: '1005', name: '左上顶点', x: 0, y: 0},
          {no: 3, type: '1001', name: '第一交接起点', x: 0, y: 0},
          {no: 4, type: '1003', name: '第二交接起点', x: 0, y: 0},
          {no: 5, type: '1007', name: '右上顶点', x: 0, y: 0},
          {no: 6, type: '1008', name: '右下底点', x: 0, y: 0},
          {no: 7, type: '1004', name: '第二交接终点', x: 0, y: 0},
          {no: 8, type: '1002', name: '第一交接终点', x: 0, y: 0},
        ];
      }
    },
    addSecoords() {
      this.secoords.visible = true;
      this.secoords.operate = 'add';
      this.secoords.formData.type = '1005';
      this.secoords.formData.name = '顶点';
    },
    editSecoords(val) {
      this.secoords.index = val.$index;
      this.secoords.operate = 'edit';
      this.secoords.title = '修改轮廓坐标';
      this.secoords.formData = JSON.parse(JSON.stringify(val.row));
      this.secoords.visible = true;
    },
    editSemp(val) {
      this.semp.index = val.$index;
      this.semp.operate = 'edit';
      this.semp.title = '修改测压管线';
      this.semp.formData = JSON.parse(JSON.stringify(val.row));
      this.initMpcd();
    },
    editBackfillList(val) {
      this.backfill.index = val.$index;
      this.backfill.operate = 'edit';
      this.backfill.title = '修改回填土层';
      this.backfill.formData = JSON.parse(JSON.stringify(val.row));
      this.backfill.visible = true;
    },
    add() {
      this.request.post("/rm-bsection/v1", this.section.formData).then(
          (res) => {
            if (res.ok) {
              this.$message.success("新增成功！");
              this.$emit('query');
              this.section.visible = false;
            } else {
              this.$message.error(res.error.message);
            }
          });
    },
    edit() {
      this.request.put("/rm-bsection/v1", this.section.formData).then(
          (res) => {
            if (res.ok) {
              this.$message.success("修改成功！");
              this.$emit('query');
              this.section.visible = false;
            } else {
              this.$message.error(res.error.message);
            }
          });
    },
    save() {
      this.$refs['df'].validate((valid) => {
        if (valid) {
          this.$confirm("确定要保存吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(
              () => {
                if (this.section.operate === 'add') {
                  this.add();
                } else {
                  this.edit();
                }
              }
          );
        } else {
          return false;
        }
      });
    },
    saveSemp() {
      this.semp.operate = 'add';
      this.semp.title = '添加测压管线'
      this.initMpcd();
    },
    saveBackfill() {
      this.backfill.operate = 'add';
      this.backfill.title = '添加回填土层';
      this.backfill.visible = true;
    },
    initMpcd() {
      this.request.get(`/rm-bmp/queryMpOrStbprp?type=0601`).then(
          (res) => {
            if (res.ok) {
              this.mpcdList = res.data;
              this.semp.visible = true;
            } else {
              this.$message.error(res.error.message);
            }
          }
      );
    },
    numberInput(val) {
      let INTEGER_LENGTH = 5;
      let DECIMAL_LENGTH = 3;
      let str = val.replace('-', '');
      let intStr, decStr;

      // 判断是否是浮点数
      if (str.indexOf('.') === -1) {
        intStr = str;
      } else {
        let arr = str.split('.');
        intStr = arr[0];
        decStr = arr[1];
      }

      // 处理整数位
      if (intStr.length > INTEGER_LENGTH) {
        intStr = intStr.substr(0, INTEGER_LENGTH);
      }

      // 处理小数位
      if (decStr && decStr.length > DECIMAL_LENGTH) {
        decStr = decStr.substr(0, DECIMAL_LENGTH);
      }

      // 组合
      if (val.indexOf('-') === -1) {
        return decStr ? intStr + '.' + decStr : intStr;
      } else {
        return decStr ? '-' + intStr + '.' + decStr : '-' + intStr;
      }
    }
  },
  mounted() {
    this.init();
  }
}
</script>

<template>
  <el-dialog
      v-dialogDrag
      :closeOnClickModal="false"
      :visible.sync="section.visible"
      class="abow_dialog"
      top="5vh"
      width="45vw"
      :fullscreen="isFullScreen"
      append-to-body
      @close="handleClose">
    <div slot="title" class="header-title">
      <div class="dgTitle">{{ section.title }}</div>
      <el-image class="dgImg2" :src="require('../../../assets/icons/dg-gb.png')" @click="section.visible = false"></el-image>
    </div>
    <el-form ref="df" :model="section.formData" :rules="rules">
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="断面名称" prop="damnm">
            <el-input v-model="section.formData.damnm" :maxlength="20"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="section.operate === 'edit'">
          <el-form-item label="断面编号" prop="damcd">
            <el-input v-model="section.formData.damcd" :maxlength="5" :disabled="section.operate === 'edit'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="浸润线X终点坐标" prop="endX">
            <el-input v-model="section.formData.endX" type="number" @input="section.formData.endX = numberInput(section.formData.endX)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="浸润线Y终点坐标" prop="endY">
            <el-input v-model="section.formData.endY" type="number" @input="section.formData.endY = numberInput(section.formData.endY)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="坝类" prop="wallType">
            <el-select v-model="section.formData.wallType" style="width: 100%" placeholder="请选择坝类" @change="handleChange">
              <el-option
                  v-for="item in typeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="序号" prop="no">
            <el-input v-model="section.formData.no" :maxlength="3"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <secoords-add :secoords.sync="secoords" :secoords-list.sync="section.formData.secoordsList"></secoords-add>
          <el-form-item label="轮廓列表" prop="secoordsList">
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-table
              :data="section.formData.secoordsList"
              border
              :default-sort="{prop: 'no', order: 'ascending'}"
              style="width: 100%">
            <el-table-column
                align="center"
                label="序号"
                prop="no">
            </el-table-column>
            <el-table-column
                align="center"
                label="轮廓类型"
                prop="name">
            </el-table-column>
            <el-table-column
                align="center"
                label="X坐标"
                prop="x">
            </el-table-column>
            <el-table-column
                align="center"
                label="Y坐标"
                prop="y">
            </el-table-column>
            <el-table-column
                align="center"
                width="100px"
                label="操作">
              <template v-slot="scope">
                <el-button type="text" size="small" @click="editSecoords(scope)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="24" style="margin-top: 20px;">
          <semp-add :semp.sync="semp" :semp-list.sync="section.formData.sempList" :mpcdList.sync="mpcdList"></semp-add>
          <el-form-item label="添加测压管线" prop="sempList">
            <el-button @click="saveSemp">添加测压管线</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-table
              :data="section.formData.sempList"
              border
              :default-sort="{prop: 'pointX', order: 'ascending'}"
              style="width: 100%">
            <el-table-column
                align="center"
                label="序号">
              <template v-slot="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="测点编号"
                width="120px"
                prop="mpnm">
            </el-table-column>
            <el-table-column
                align="center"
                label="监测项目"
                width="150px"
                prop="name">
            </el-table-column>
            <el-table-column
                align="center"
                label="管口X坐标"
                width="100px"
                prop="tbbtX">
            </el-table-column>
            <el-table-column
                align="center"
                label="管口Y坐标"
                width="100px"
                prop="tbbtY">
            </el-table-column>
            <el-table-column
                align="center"
                label="管底Y坐标"
                width="100px"
                prop="tbtpY">
            </el-table-column>
            <el-table-column
                align="center"
                width="100px"
                label="操作">
              <template v-slot="scope">
                <el-button type="text" size="small" @click="editSemp(scope)">编辑</el-button>
                <el-button type="text" size="small" @click="section.formData.sempList.splice(scope.$index,1)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="24" style="margin-top: 20px;">
          <backfill-add :backfill.sync="backfill" :backfill-list.sync="section.formData.backfillList"></backfill-add>
          <el-form-item label="添加回填土层" prop="backfillList">
            <el-button @click="saveBackfill">添加回填土层</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-table
              :data="section.formData.backfillList"
              border
              :default-sort="{prop: 'pointX', order: 'ascending'}"
              style="width: 100%">
            <el-table-column
                align="center"
                prop="no"
                label="序号">
            </el-table-column>
            <el-table-column
                align="center"
                label="X坐标"
                prop="x">
            </el-table-column>
            <el-table-column
                align="center"
                label="Y坐标"
                prop="y">
            </el-table-column>
            <el-table-column
                align="center"
                width="100px"
                label="操作">
              <template v-slot="scope">
                <el-button type="text" size="small" @click="editBackfillList(scope)">编辑</el-button>
                <el-button type="text" size="small" @click="section.formData.backfillList.splice(scope.$index,1)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
       <el-button @click="section.visible = false" class="dgClose">关 闭</el-button>
        <template>
          <el-button
              slot="reference"
              type="primary"
              @click="save"
              class="dgSave">保 存
          </el-button>
        </template>
    </span>
  </el-dialog>
</template>

<style scoped>

::v-deep .el-dialog {
  margin: 0 auto;
  overflow: hidden;
}

::v-deep .el-dialog__header {
  height: 6vh;
  line-height: 6vh;
  padding: 0;
  background-color: #f9f9ff;
  position: relative;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

::v-deep .el-dialog__headerbtn {
  position: absolute;
  top: 0px;
  right: 10px;
  height: 5vh;
  line-height: 5vh;
}

::v-deep .el-dialog__body {
  padding: 10px 20px 0px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  position: absolute;
  left: 0;
  top: 5vh;
  bottom: 70px;
  right: 0;
  overflow: auto;
}

::v-deep .dialog-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #fff;
  width: 100%;
  height: 70px;
  z-index: 10;
  display: flex;
  justify-content: flex-end;
  align-items: Center;
  box-sizing: border-box;
  padding-right: 20px;
}

::v-deep .el-dialog {
  height: 70%;
}

.dgTitle{
  margin-left: 2vh;
  font-family: PingFang SC;
  font-size: 1.6vh;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0vh;
  color: #323232;
  line-height: 6vh;
  display: inline-block;
  vertical-align: middle;
}

.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
}

.dgImg2{
  position: absolute;
  right: 2vh;
  top:1.5vh;
  width: 3vh;
  height: 3vh;
  line-height: 6vh;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}

.dgClose{
  width: 8vh;
  height: 3vh;
  font-family: PingFang SC;
  font-size: 1.2vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vh;
  letter-spacing: 0vh;
  color: #0066ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: solid 1px #53abfd;
  border-radius: 2px;
}

.dgSave{
  width: 8vh;
  height: 3vh;
  background-color: #53abfd;
  border-radius: 0vh;
  font-family: PingFang SC;
  font-size: 1.2vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vh;
  letter-spacing: 0vh;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input[type="number"] {
  -moz-appearance: textfield !important;
}
</style>